import { useForm as useReactHookForm } from 'react-hook-form';

export const useForm = ({ defaultValues, resolver }) => {
    return useReactHookForm({ defaultValues, resolver });
};
